import { BooleanCons, StringConst } from 'src/app/constants/const';
import { TypeReportsFilter, TypeSAPFilter, TypeSAPReport, TypeSAPReportKey } from 'src/app/constants/sap.filters.titles';
import { FilterSAPComboItem } from '../http/sapReports.model';

export interface DictSAPFilterDialog {
    [key: string]: string;
}
export interface DictSAPFilterDialogTypes {
    [key: string]: TypeSAPFilter;
}

export interface DictSAPFilterDialogConfig {
    [key: string]: SAPFilter;
}

export interface DictFiltersSaved {
    [key: string]: { [key: string]: FilterSAPComboItem[] };
}

export interface DictActiveFilters {
    [key: string]: { [key: string]: SAPFilterRequest };
}

export class SapFilterDialogConfig {
    filters: SAPFilter[];
    typeReport: TypeSAPReport;
    reportKey: TypeSAPReportKey;
    constructor() {
        this.filters = [];
        this.typeReport = TypeSAPReport.clientWallet;
        this.reportKey = TypeSAPReportKey.clientWallet;
    }
}
export class SAPFilterItemRequest {
    slpCode: string;
    typeReport: string;
    valueType: string;
    field: string;
    constructor() {
        this.slpCode = StringConst.empty;
        this.typeReport = StringConst.empty;
        this.valueType = StringConst.empty;
        this.field = StringConst.empty;
    }
}
export class SAPFilterRequest {
    startValue: string;
    finishValue: string;
    valueType: string;
    type: string;
    field: string;
    constructor() {
        this.startValue = StringConst.empty;
        this.finishValue = StringConst.empty;
        this.valueType = StringConst.empty;
        this.type = StringConst.empty;
        this.field = StringConst.empty;
    }
}

export class SapFilterTextValue {
    data: SAPFilterRequest;
    valid: boolean;
    cleaned: boolean;
    constructor() {
        this.data = new SAPFilterRequest();
        this.valid = BooleanCons.false;
        this.cleaned = BooleanCons.false;
    }
}
export class SAPFilter {
    title: string;
    filterName: string;
    value: TypeSAPFilter;
    options: ComboboxFiltersSAP[];
    displayedColumns: DisplayedColumns;
    constructor() {
        this.title = StringConst.empty;
        this.filterName = StringConst.empty;
        this.value = TypeSAPFilter.string;
        this.options = [];
        this.displayedColumns = new DisplayedColumns();
    }
}

export class DisplayedColumns {
    initialValue: boolean;
    lastValue: boolean;
    constructor() {
        this.initialValue = BooleanCons.true;
        this.lastValue = BooleanCons.true;
    }
}

export class ComboboxFiltersSAP {
    description: string;
    value: TypeReportsFilter;
    constructor() {
        this.description = StringConst.empty;
        this.value = TypeReportsFilter.default;
    }
}

export class JSONFilters {
    config: SAPFilter[];
    constructor() {
        this.config = [];
    }
}
